export const editOffer = (sdp, nonAdvertisedCodecs) => {
  const sections = sdp.split('m=');

  for (let i = 0; i < sections.length; i++) {
    if (sections[i].startsWith('audio')) {
      sections[i] = enableStereoOpus(sections[i]);

      if (nonAdvertisedCodecs.includes('pcma/8000/2')) {
        sections[i] = enableStereoPcmau(sections[i]);
      }

      if (nonAdvertisedCodecs.includes('multiopus/48000/6')) {
        sections[i] = enableMultichannelOpus(sections[i]);
      }

      if (nonAdvertisedCodecs.includes('L16/48000/2')) {
        sections[i] = enableL16(sections[i]);
      }

      break;
    }
  }

  return sections.join('m=');
};

const enableMultichannelOpus = (section) => {
  let lines = section.split('\r\n');

  let payloadType = findFreePayloadType(lines[0]);
  lines[0] += ` ${payloadType}`;
  lines.splice(
    lines.length - 1,
    0,
    `a=rtpmap:${payloadType} multiopus/48000/3`
  );
  lines.splice(
    lines.length - 1,
    0,
    `a=fmtp:${payloadType} channel_mapping=0,2,1;num_streams=2;coupled_streams=1`
  );
  lines.splice(lines.length - 1, 0, `a=rtcp-fb:${payloadType} transport-cc`);

  payloadType = findFreePayloadType(lines[0]);
  lines[0] += ` ${payloadType}`;
  lines.splice(
    lines.length - 1,
    0,
    `a=rtpmap:${payloadType} multiopus/48000/4`
  );
  lines.splice(
    lines.length - 1,
    0,
    `a=fmtp:${payloadType} channel_mapping=0,1,2,3;num_streams=2;coupled_streams=2`
  );
  lines.splice(lines.length - 1, 0, `a=rtcp-fb:${payloadType} transport-cc`);

  payloadType = findFreePayloadType(lines[0]);
  lines[0] += ` ${payloadType}`;
  lines.splice(
    lines.length - 1,
    0,
    `a=rtpmap:${payloadType} multiopus/48000/5`
  );
  lines.splice(
    lines.length - 1,
    0,
    `a=fmtp:${payloadType} channel_mapping=0,4,1,2,3;num_streams=3;coupled_streams=2`
  );
  lines.splice(lines.length - 1, 0, `a=rtcp-fb:${payloadType} transport-cc`);

  payloadType = findFreePayloadType(lines[0]);
  lines[0] += ` ${payloadType}`;
  lines.splice(
    lines.length - 1,
    0,
    `a=rtpmap:${payloadType} multiopus/48000/6`
  );
  lines.splice(
    lines.length - 1,
    0,
    `a=fmtp:${payloadType} channel_mapping=0,4,1,2,3,5;num_streams=4;coupled_streams=2`
  );
  lines.splice(lines.length - 1, 0, `a=rtcp-fb:${payloadType} transport-cc`);

  payloadType = findFreePayloadType(lines[0]);
  lines[0] += ` ${payloadType}`;
  lines.splice(
    lines.length - 1,
    0,
    `a=rtpmap:${payloadType} multiopus/48000/7`
  );
  lines.splice(
    lines.length - 1,
    0,
    `a=fmtp:${payloadType} channel_mapping=0,4,1,2,3,5,6;num_streams=4;coupled_streams=4`
  );
  lines.splice(lines.length - 1, 0, `a=rtcp-fb:${payloadType} transport-cc`);

  payloadType = findFreePayloadType(lines[0]);
  lines[0] += ` ${payloadType}`;
  lines.splice(
    lines.length - 1,
    0,
    `a=rtpmap:${payloadType} multiopus/48000/8`
  );
  lines.splice(
    lines.length - 1,
    0,
    `a=fmtp:${payloadType} channel_mapping=0,6,1,4,5,2,3,7;num_streams=5;coupled_streams=4`
  );
  lines.splice(lines.length - 1, 0, `a=rtcp-fb:${payloadType} transport-cc`);

  return lines.join('\r\n');
};

const enableStereoOpus = (section) => {
  let opusPayloadFormat = '';
  let lines = section.split('\r\n');

  for (let i = 0; i < lines.length; i++) {
    if (
      lines[i].startsWith('a=rtpmap:') &&
      lines[i].toLowerCase().includes('opus/')
    ) {
      opusPayloadFormat = lines[i].slice('a=rtpmap:'.length).split(' ')[0];
      break;
    }
  }

  if (opusPayloadFormat === '') {
    return section;
  }

  for (let i = 0; i < lines.length; i++) {
    if (lines[i].startsWith('a=fmtp:' + opusPayloadFormat + ' ')) {
      if (!lines[i].includes('stereo')) {
        lines[i] += ';stereo=1';
      }
      if (!lines[i].includes('sprop-stereo')) {
        lines[i] += ';sprop-stereo=1';
      }
    }
  }

  return lines.join('\r\n');
};

const findFreePayloadType = (firstLine) => {
  const payloadTypes = firstLine.split(' ').slice(3);
  for (let i = 96; i <= 127; i++) {
    if (!payloadTypes.includes(i.toString())) {
      return i.toString();
    }
  }
  throw Error('unable to find a free payload type');
};

const enableStereoPcmau = (section) => {
  let lines = section.split('\r\n');

  let payloadType = findFreePayloadType(lines[0]);
  lines[0] += ` ${payloadType}`;
  lines.splice(lines.length - 1, 0, `a=rtpmap:${payloadType} PCMU/8000/2`);
  lines.splice(lines.length - 1, 0, `a=rtcp-fb:${payloadType} transport-cc`);

  payloadType = findFreePayloadType(lines[0]);
  lines[0] += ` ${payloadType}`;
  lines.splice(lines.length - 1, 0, `a=rtpmap:${payloadType} PCMA/8000/2`);
  lines.splice(lines.length - 1, 0, `a=rtcp-fb:${payloadType} transport-cc`);

  return lines.join('\r\n');
};

const enableL16 = (section) => {
  let lines = section.split('\r\n');

  let payloadType = findFreePayloadType(lines[0]);
  lines[0] += ` ${payloadType}`;
  lines.splice(lines.length - 1, 0, `a=rtpmap:${payloadType} L16/8000/2`);
  lines.splice(lines.length - 1, 0, `a=rtcp-fb:${payloadType} transport-cc`);

  payloadType = findFreePayloadType(lines[0]);
  lines[0] += ` ${payloadType}`;
  lines.splice(lines.length - 1, 0, `a=rtpmap:${payloadType} L16/16000/2`);
  lines.splice(lines.length - 1, 0, `a=rtcp-fb:${payloadType} transport-cc`);

  payloadType = findFreePayloadType(lines[0]);
  lines[0] += ` ${payloadType}`;
  lines.splice(lines.length - 1, 0, `a=rtpmap:${payloadType} L16/48000/2`);
  lines.splice(lines.length - 1, 0, `a=rtcp-fb:${payloadType} transport-cc`);

  return lines.join('\r\n');
};

export const parseOffer = (sdp) => {
  const ret = {
    iceUfrag: '',
    icePwd: '',
    medias: [],
  };

  for (const line of sdp.split('\r\n')) {
    if (line.startsWith('m=')) {
      ret.medias.push(line.slice('m='.length));
    } else if (ret.iceUfrag === '' && line.startsWith('a=ice-ufrag:')) {
      ret.iceUfrag = line.slice('a=ice-ufrag:'.length);
    } else if (ret.icePwd === '' && line.startsWith('a=ice-pwd:')) {
      ret.icePwd = line.slice('a=ice-pwd:'.length);
    }
  }

  return ret;
};

export const supportsNonAdvertisedCodec = (codec, fmtp) =>
  new Promise((resolve, reject) => {
    const pc = new RTCPeerConnection({ iceServers: [] });
    pc.addTransceiver('audio', { direction: 'recvonly' });

    pc.createOffer()
      .then((offer) => {
        if (offer.sdp.includes(' ' + codec)) {
          // codec is advertised, there's no need to add it manually
          resolve(false);
          return;
        }
        const sections = offer.sdp.split('m=audio');
        const lines = sections[1].split('\r\n');
        lines[0] += ' 118';
        lines.splice(lines.length - 1, 0, 'a=rtpmap:118 ' + codec);
        if (fmtp !== undefined) {
          lines.splice(lines.length - 1, 0, 'a=fmtp:118 ' + fmtp);
        }
        sections[1] = lines.join('\r\n');
        offer.sdp = sections.join('m=audio');
        return pc.setLocalDescription(offer);
      })
      .then(() => {
        return pc.setRemoteDescription(
          new RTCSessionDescription({
            type: 'answer',
            sdp:
              'v=0\r\n' +
              'o=- 6539324223450680508 0 IN IP4 0.0.0.0\r\n' +
              's=-\r\n' +
              't=0 0\r\n' +
              'a=fingerprint:sha-256 0D:9F:78:15:42:B5:4B:E6:E2:94:3E:5B:37:78:E1:4B:54:59:A3:36:3A:E5:05:EB:27:EE:8F:D2:2D:41:29:25\r\n' +
              'm=audio 9 UDP/TLS/RTP/SAVPF 118\r\n' +
              'c=IN IP4 0.0.0.0\r\n' +
              'a=ice-pwd:7c3bf4770007e7432ee4ea4d697db675\r\n' +
              'a=ice-ufrag:29e036dc\r\n' +
              'a=sendonly\r\n' +
              'a=rtcp-mux\r\n' +
              'a=rtpmap:118 ' +
              codec +
              '\r\n' +
              (fmtp !== undefined ? 'a=fmtp:118 ' + fmtp + '\r\n' : ''),
          })
        );
      })
      .then(() => {
        resolve(true);
      })
      .catch((err) => {
        resolve(false);
      })
      .finally(() => {
        pc.close();
      });
  });

export const generateSdpFragment = (od, candidates) => {
  const candidatesByMedia = {};
  for (const candidate of candidates) {
    const mid = candidate.sdpMLineIndex;
    if (candidatesByMedia[mid] === undefined) {
      candidatesByMedia[mid] = [];
    }
    candidatesByMedia[mid].push(candidate);
  }

  let frag =
    'a=ice-ufrag:' + od.iceUfrag + '\r\n' + 'a=ice-pwd:' + od.icePwd + '\r\n';

  let mid = 0;

  for (const media of od.medias) {
    if (candidatesByMedia[mid] !== undefined) {
      frag += 'm=' + media + '\r\n' + 'a=mid:' + mid + '\r\n';

      for (const candidate of candidatesByMedia[mid]) {
        frag += 'a=' + candidate.candidate + '\r\n';
      }
    }
    mid++;
  }

  return frag;
};
